/**
 * Wallet/web3 wiring for the dashboard.
 *
 * `createAutheWagmiConfig` derives the EVM chain list + transports straight from
 * the shared `@authe/fe-commons` chain registry (so the wallet can only ever talk
 * to chains the platform supports) and defaults to the injected (browser-
 * extension) connector. Built once as a module singleton — wagmi configs are
 * stateful and must not be recreated on re-render.
 */
import { createAutheWagmiConfig } from "@authe/web3";

export const wagmiConfig = createAutheWagmiConfig({
  // `true` even though this is a pure SPA. With `false`, wagmi's `Hydrate` runs
  // its `onMount` DURING RENDER — on every render of the provider, not once — so
  // restoring the connection wrote to the wallet store while React was
  // rendering, and the header's `WalletButton` logged "Cannot update a component
  // while rendering a different component". `true` moves the same restore and
  // reconnect into an effect that runs once.
  ssr: true,
});
